import { Heading, Body, Container, Box } from '@hover/blueprint';
import React from 'react';

interface Props {
  setCurrentSection: React.Dispatch<React.SetStateAction<string>>;
}

const CareersHeaderDescription: React.FC<Props> = () => (
  <Container
    maxW="3xl"
    pt={97}
    pb={97}
    position={{ base: 'relative', desktop: 'absolute' }}
    top={{ base: 0, desktop: '229px' }}
    left={{ desktop: '50%' }}
    transform="auto"
    translateX={{ desktop: '-50%' }}
    translateY={{ desktop: '-50%' }}
    mb={{ base: 900, desktop: 0 }}
  >
    <Box flexDir="column" alignItems="center">
      <Heading
        textAlign="center"
        size={{ base: 500, tablet: 600, desktop: 700 }}
        style={{ marginBottom: 24 }}
        fontWeight={{ base: 600, desktop: 600 }}
      >
        Creativity is a team sport
      </Heading>
      <Heading
        size={{ base: 300, desktop: 500 }}
        style={{ fontWeight: 400 }}
        textAlign="center"
      >
        “And while we build a new category of platform and data, we also aim to
        build a different kind of company... We can’t lose if we stick to our
        shared team values. ”
      </Heading>
      <Body size={500} textAlign="center">
        A.J., HOVER Founder & CEO
      </Body>
    </Box>
  </Container>
);

export default CareersHeaderDescription;
